import React, { FC } from 'react';
import cx from 'clsx';
import styles from './PerkImage.module.scss';

type PerkImageProps = React.HTMLAttributes<HTMLImageElement> & {
  iconUrl: string;
  backgroundIconUrl: string;
  disabled?: boolean;
  children?: never;
  src?: never;
  style?: never
}

export const PerkImage : FC<PerkImageProps> = ({ iconUrl, backgroundIconUrl, disabled, ...props }) => {

  return (
    <img
      className={cx(styles.icon, {
        [styles.disabled]: disabled
      })}
      alt={''}
      src={iconUrl}
      style={{
        backgroundImage: `url(${backgroundIconUrl})`
      }}
      {...props}
    />
  );
};
